import React, { ReactNode } from 'react';
import { classnames } from 'helpers/utils';
import { CheckCircleFilledIcon } from 'assets/icons';
import { Checkbox } from 'common/checkbox';
import styles from './drop-down-list-item.module.scss';

type CheckboxIconItem = {
  isChecked: boolean;
  onChange: () => void;
  itemKey: string;
};

interface DropDownListItemProps {
  children: ReactNode;
  leftIcon?: ReactNode;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
  checkboxItem?: CheckboxIconItem;
  // The confirmation look (e.g. "Email copied"): a check in place of the icon,
  // on a brand tint.
  success?: boolean;
}

export const DropDownListItem: React.FC<DropDownListItemProps> = ({
  children,
  onClick,
  leftIcon,
  disabled = false,
  className = '',
  checkboxItem,
  success = false,
}) => (
  <button
    type="button"
    className={classnames(styles.navItem, className, {
      [styles.disabled]: disabled,
      [styles.success]: success,
    })}
    onClick={onClick}
    disabled={disabled}
  >
    {checkboxItem && (
      <Checkbox
        isChecked={checkboxItem.isChecked}
        itemKey={checkboxItem.itemKey}
        onChange={checkboxItem.onChange}
      />
    )}
    {!checkboxItem && (success || leftIcon) && (
      <div className={styles.icon}>
        {success ? <CheckCircleFilledIcon /> : leftIcon}
      </div>
    )}
    <span
      className={classnames(
        styles.content,
        'text__body__semi__bold__small__gray700',
        { [styles.contentWithIcon]: !checkboxItem && !!leftIcon },
      )}
    >
      {children}
    </span>
  </button>
);
